export const environment = {
  production: true,
  apiURL: 'https://zodi-backend.onrender.com/api/v1/',
};
